import ScrollModal from "@/components/common/scroll-modal";
import { Heading, Button, TextAreaField } from "@elaniintc/goes-design-system";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

interface NewFlowModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { type: "APPROVED" | "DENIED"; comment: string }) => void;
  isLoading?: boolean;
}

const schema = z.object({
  type: z.enum(["APPROVED", "DENIED"]),
  comment: z
    .string()
    .min(1, "El comentario es obligatorio")
    .max(250, "El comentario no puede exceder los 250 caracteres"),
});
type ResolutionSchema = z.infer<typeof schema>;

export default function FlowResolutionModal({
  open,
  onClose,
  onSubmit,
  isLoading = false,
}: NewFlowModalProps) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<ResolutionSchema>({
    resolver: zodResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      comment: "",
    },
  });

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <ScrollModal
      isOpen={open}
      onClose={handleCloseModal}
      title="Crear Flujo principal"
      description="Este flujo es iniciado por el tramitadór, al cual todos los flujos secundarios estarán conectados."
      srOnlyDescription={false}
      modalContentClassName="w-full max-w-[580px] max-h-[680px] flex flex-col pb-6"
    >
      <div className="flex py-8 justify-center flex-col items-center">
        <Heading variant="h2" className="!mb-0">
          Resolución de revisión
        </Heading>
        <p className="text-center text-body font-normal leading-3xl">
          Aprueba o rechaza la validez del flujo con base a la revisión
          realizada.
        </p>
      </div>
      <div className="flex flex-col">
        <form
          onSubmit={handleSubmit((data) => {
            onSubmit(data);
          })}
          className="flex flex-col flex-1 min-h-0 px-4 sm:px-8 gap-8"
        >
          <TextAreaField
            label="Comentario general"
            required
            error={errors.comment?.message}
            placeholder="Escribe el nombre del flujo"
            {...register("comment")}
          />
          <div className="w-full grid grid-cols-1 tablet:grid-cols-4 py-3 gap-3">
            <Button
              variant="tertiary"
              size="sm"
              type="button"
              disabled={isLoading}
              onClick={handleCloseModal}
              className="cursor-pointer"
            >
              Cancelar
            </Button>
            <div />
            <Button
              variant="danger-tertiary"
              size="sm"
              type="submit"
              //disabled={!isValid || isLoadingFlows}
              isLoading={isLoading}
              className="cursor-pointer disabled:bg-neutral-object-accent disabled:text-on-disabled disabled:border-none disabled:shadow-none"
              onClick={(e) => {
                e.preventDefault();
                setValue("type", "DENIED");
                handleSubmit((data) => {
                  onSubmit(data);
                })();
              }}
            >
              Rechazar
            </Button>
            <Button
              variant="default"
              size="sm"
              type="submit"
              //disabled={!isValid || isLoadingFlows}
              isLoading={isLoading}
              className="cursor-pointer disabled:bg-neutral-object-accent disabled:text-on-disabled disabled:border-none disabled:shadow-none"
              onClick={(e) => {
                e.preventDefault();
                setValue("type", "APPROVED");
                handleSubmit((data) => {
                  onSubmit(data);
                })();
              }}
            >
              Aceptar
            </Button>
          </div>
        </form>
      </div>
    </ScrollModal>
  );
}
